import { API, postJSON } from "../../api.js";
import { wireCommandButton } from "../../app/commands.js";
import { $, esc, fmtMoney } from "../../ui/format.js";
import { helpIcon } from "../../ui/help.js";
import { openAmountModal, toast } from "../../ui/modals.js";

// ---------------------------------------------------------------- Banking & Debt

async function renderBanking(main, snap) {
  main.innerHTML = `
    <h2 class="panel-title">Banking &amp; Debt — Month ${snap.month} ${helpIcon("banking")}</h2>
    <div class="plain-english-card" id="banking-summary">Loading…</div>
    <div class="commands">
      <button id="btn-take-loan">Take Loan (auto-shop cheapest)</button>
      <button id="btn-pay-down-debt">Pay Down Debt</button>
    </div>
    <h3 style="font-family:var(--font-display); font-size:16px; margin-bottom:12px;">Active Loans</h3>
    <div id="loans-list">Loading…</div>
    <h3 style="font-family:var(--font-display); font-size:16px; margin:28px 0 12px;">Bank Quotes (live, based on your current leverage)</h3>
    <div id="bank-quotes">Loading…</div>
  `;
  wireCommandButton($("btn-take-loan"), "loan");
  wireCommandButton($("btn-pay-down-debt"), "paydebt");
  const [loans, banks] = await Promise.all([
    fetch(`${API}/loans`).then((x) => x.json()),
    fetch(`${API}/banks`).then((x) => x.json()),
  ]);

  const totalDebt = loans.reduce((sum, l) => sum + l.outstanding_balance, 0);
  const blendedRate = totalDebt > 0
    ? loans.reduce((sum, l) => sum + l.outstanding_balance * l.interest_rate, 0) / totalDebt
    : 0;
  const de = snap.ratios.debt_to_equity;
  $("banking-summary").innerHTML = loans.length
    ? `You owe ${fmtMoney(totalDebt)} across ${loans.length} loan${loans.length > 1 ? "s" : ""}, at a blended rate of ${(blendedRate * 100).toFixed(1)}%.
       ${de === null ? "" : de > 2 ? "⚠ Your debt-to-equity is high, which raises the rates banks will quote you next." : "Your leverage is manageable — banks below should quote reasonable rates."}`
    : `You're debt-free. Taking a loan below is optional — it can fund faster growth, but every dollar borrowed adds a real monthly interest cost.`;

  $("loans-list").innerHTML = loans.length ? `
    <table class="ledger">
      <tr><th>Bank</th><th>Outstanding</th><th>Rate</th><th>Term</th><th>Taken</th></tr>
      ${loans.map((l) => `
        <tr>
          <td class="label">${esc(l.bank_name)}</td>
          <td class="mono">${fmtMoney(l.outstanding_balance)}</td>
          <td class="mono">${(l.interest_rate * 100).toFixed(1)}%</td>
          <td class="mono">${l.term_months}mo</td>
          <td class="mono">M${l.month_taken}</td>
        </tr>
      `).join("")}
    </table>
  ` : `<p style="color:var(--text-mid)">No active loans.</p>`;

  $("bank-quotes").innerHTML = `
    <table class="ledger">
      <tr><th>Bank</th><th>Rate Quoted</th><th>Min Loan</th><th>Max Loan</th><th>Max D/E</th><th></th></tr>
      ${banks.map((b) => `
        <tr>
          <td class="label">${esc(b.bank_name)}</td>
          <td class="mono">${b.eligible ? (b.quoted_rate * 100).toFixed(1) + "%" : "—"}</td>
          <td class="mono">${fmtMoney(b.min_loan)}</td>
          <td class="mono">${fmtMoney(b.max_loan)}</td>
          <td class="mono">${b.max_debt_to_equity}x</td>
          <td>${b.eligible ? `<button data-bank="${esc(b.bank_name)}">Borrow</button>` : `<span style="color:var(--oxblood); font-size:11px;">Declines — over leverage limit</span>`}</td>
        </tr>
      `).join("")}
    </table>
  `;
  $("bank-quotes").querySelectorAll("[data-bank]").forEach((btn) => {
    btn.addEventListener("click", () => openAmountModal(`Borrow from ${btn.dataset.bank}`,
      `How much to borrow from ${btn.dataset.bank} ($)?`, async (amount) => {
        const res = await postJSON("/loans/take", { bank_name: btn.dataset.bank, amount });
        await window.refreshAll();
        toast(res.message);
      }, false, 200000));
  });
}

// Late-bound: a later view may replace these (window.X = ...), so callers use window.X.
window.renderBanking = renderBanking;
